import { Data } from '@blade/std-lib'

export const NativeError = Error

export class UnknownError extends Data.TaggedError('UnknownError')<{
  error?: unknown
  message?: string
}> {
  static fromUnknown = (error?: unknown): UnknownError => {
    if (error instanceof Error) {
      return new UnknownError({ error })
    }

    if (typeof error === 'string') {
      return new UnknownError({ message: error })
    }

    return new UnknownError({})
  }

  static fallbackToUnknown = <T = unknown>(error: T): UnknownError => {
    return error instanceof UnknownError
      ? error
      : UnknownError.fromUnknown(error)
  }
}

export class NotFoundError extends Data.TaggedError('NotFoundError') {}
export class TimeoutError extends Data.TaggedError('TimeoutError') {}
